import React, { useContext } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../Main';

let options = ['', 'MOST_VIEWED', 'NEWEST_PUBLISHED', 'NEWEST_ADDED'];

export default function Dropdown({ anchorEl, setAnchorEl, handleClick, field, setField }) {
  const { t, i18n } = useTranslation();
  const open = Boolean(anchorEl);
  const { isAuth } = useContext(AuthContext);
  const handleClose = (option) => {
    setAnchorEl(null);
    if (typeof option === 'string') setField(option);
  };
  React.useEffect(() => {
    if (isAuth) options = [...options, 'RECENT_READ', 'FAVORITES'];
  }, [isAuth]);
  return (
    <>
      <button aria-label="more" aria-controls="long-menu" aria-haspopup="true" className="type-button" onClick={handleClick}>
        {field ? t('search.field.' + field) : t('search.field.all')}
        <IconButton aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
      </button>

      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: '100%',
            width: '20ch',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} selected={option === field} onClick={() => handleClose(option)}>
            {option ? t('search.field.' + option) : t('search.field.all')}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
